import { styled } from '@linaria/react';

export const Wrapper = styled.div`
	display: flex;
	overflow: clip;
	max-width: 200px;
	height: auto;
	flex-flow: column nowrap;
	align-items: center;
	justify-content: center;
	padding: 16px;
	border-radius: var(--radius-m);
	margin-bottom: 16px;
	margin-left: 24px;
	background: var(--color-black-l);
	gap: var(--gap-s);
	grid-area: gen-loader;
	interpolate-size: allow-keywords;
	transition: height 0.25s ease allow-discrete;
	@starting-style {
		height: 0;
	}
	button {
		width: 100%;
		padding: 11px 8px;
		font-size: var(--font-size-base);
		gap: 0;
	}
`;

export const LoaderWrapper = styled.div<{ pro: boolean }>`
	position: relative;
	display: flex;
	width: 64px;
	align-items: center;
	justify-content: center;
	border-radius: 100%;
	background: var(--color-black-solid);
	&::after {
		position: absolute;
		right: 0;
		left: 0;
		display: ${({ pro }) => (pro ? 'block' : 'none')};
		width: 100%;
		color: inherit;
		content: 'Pro';
		font-size: var(--font-size-base);
		font-weight: var(--font-weight-semibold);
		text-align: center;
		text-transform: uppercase;
	}
	.loader {
		transform: scale(1.5);
	}
`;

export const ButtonContent = styled.span`
	color: inherit;
	span {
		color: var(--bot-color-main);
		text-transform: uppercase;
	}
`;
